/* Själva visningen av ett hämtat dokument – utbruten ur DocumentPreviewModal
   (2026-10-23, Mikael F14). Används av dialogen och av KanAI:s källpanel.
   Tar emot resultatet från useDocumentPreview. */
import React from 'react';
import DocxPreview from '../DocxPreview';
import XlsxPreview from '../XlsxPreview';
import ViewerCanvas from '../../modules/BimViewer/ViewerCanvas';
import DwgSvgViewer from '../DwgSvgViewer';
import ApsViewerPanel from '../ApsViewerPanel';
import PdfViewer from '../PdfViewer';
import { PREVIEW_IFRAME_SANDBOX, UnsupportedPreviewNotice } from '../../utils/filePreview';
import { APS_EXTENSIONS, parseIdsFromUrl } from './useDocumentPreview';

export default function DocumentPreviewBody({ document, preview }) {
  const {
    previewUrl, loading, setError, previewKind, ifcFile, markeradSida, apsConfigured,
    safeName, downloadUrlAbsolute, effectiveExt,
  } = preview;

  const ext = String(effectiveExt || '').toLowerCase();
  const ids = parseIdsFromUrl(document?.download_url);
  const useAps = apsConfigured && ids && APS_EXTENSIONS.has(ext);

  if (useAps) {
    return (
      <ApsViewerPanel
        projectId={ids.projectId}
        documentId={ids.documentId}
        filename={safeName}
        onError={(msg) => setError(msg)}
      />
    );
  }

  if (loading) {
    return (
      <div className="flex-1 flex items-center justify-center text-sm text-slate-500 dark:text-slate-300">
        Laddar förhandsvisning...
      </div>
    );
  }

  if (ifcFile) {
    return (
      <div className="w-full h-full p-2">
        <ViewerCanvas
          objects={[]}
          selectedId={null}
          onSelect={() => {}}
          onClear={() => {}}
          onReset={() => {}}
          ifcFile={ifcFile}
          resetToken={`${document?.id || ''}:${document?.current_version || document?.currentVersion || 0}`}
          onIfcLoaded={() => {}}
        />
      </div>
    );
  }

  if (previewUrl) {
    /* previewKind kommer ur vitlistan i utils/filePreview och blobben är
       ombyggd med motsvarande MIME – lagrad typ styr aldrig renderingen. */
    if (previewKind === 'dwg') {
      return (
        <div className="w-full h-full p-2">
          <DwgSvgViewer
            svgUrl={previewUrl}
            filename={safeName}
            onError={(msg) => setError(msg)}
          />
        </div>
      );
    }
    if (previewKind === 'docx') {
      return <DocxPreview url={previewUrl} />;
    }
    if (previewKind === 'xlsx') {
      return <XlsxPreview url={previewUrl} fallbackUrl={downloadUrlAbsolute} />;
    }
    if (previewKind === 'pdf') {
      /* pdf.js i canvas – ingen iframe, ingen HTML-parsning. */
      return (
        <PdfViewer
          url={previewUrl}
          className="w-full h-full"
          autoFitWidth
          initialPage={markeradSida || Number(document?.page) || undefined}
        />
      );
    }
    if (previewKind === 'image') {
      return <img src={previewUrl} alt={safeName} className="w-full h-full object-contain" />;
    }
    if (previewKind === 'text') {
      return (
        <iframe
          src={previewUrl}
          title={safeName}
          sandbox={PREVIEW_IFRAME_SANDBOX}
          className="w-full h-full border-0"
        />
      );
    }
    return (
      <UnsupportedPreviewNotice
        filename={safeName}
        downloadHref={previewUrl}
      />
    );
  }

  return (
    <div className="flex-1 flex items-center justify-center text-sm text-slate-500 dark:text-slate-400">
      Ingen förhandsvisning tillgänglig.
    </div>
  );
}
